import React from 'react';
import PropTypes from 'prop-types';
import ContainerStyled from './styles/PlanErrorStyled';
import Button from '../../General/Button';
import { ReactComponent as IconGhost } from '../../../images/errores/fantasma.svg';

const PlanError = ({ loadData }) => {
  return (
    <ContainerStyled>
      <picture>
        <IconGhost />
      </picture>
      <h2>PLAN RECURRENTE NO DISPONIBLE</h2>
      <p>Algo falló, tu página no pudo ser cargada</p>
      <p>Vuelve a intentarlo más tarde.</p>
      <Button
        maxWidth="205px"
        color="bubbleGum"
        margin="30px auto"
        height="48px"
        click={loadData}
      >
        Reintentar
      </Button>
    </ContainerStyled>
  );
};

PlanError.propTypes = {
  loadData: PropTypes.func.isRequired,
};

export default PlanError;
